import { render, staticRenderFns } from "./RegistrationLink.vue?vue&type=template&id=7800f646&scoped=true&"
import script from "./RegistrationLink.vue?vue&type=script&lang=js&"
export * from "./RegistrationLink.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationLink.vue?vue&type=style&index=0&id=7800f646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7800f646",
  null
  
)

export default component.exports